<template>
<div id="login-form" v-if="userContext">
  <div class="form-group first-step" :class="{'error' : Validator.hasError('login-email')}" v-if="loginPhase == 'setting-email'">

    <form @submit="ignoreForm">
    <!-- disabled auto login because users are disabled -->
    <!-- @updated="emailChanged(true)" -->
    <text-field :data="credentials" name="email" label='E-mail' kind='input' inputType='email' :required=true placeholder='jan@novak.cz' helpText='Tvůj e-mail potřebujeme, abychom Tě mohli informovat o stavu objednávky a příště jsi nemusel/a vyplňovat své údaje. A protože myslíme i na stav Tvé mysli, nemusíš vymýšlet heslo!'
      @updated="emailChanged"></text-field>




    <!-- submit button -->
    <a id="login-button" href="javascript:" v-if="showLoginButton" class="pfm-button icononly" :class="[loginState, {'shake': loginBtnShaking}]" @click="submit()">
      <div v-if="loginState == 'init'">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="''" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.682 18.1a.34.34 0 00.481 0l5.935-5.935a.34.34 0 000-.482l-5.935-5.935a.34.34 0 00-.481 0l-.562.562a.34.34 0 000 .482l4.396 4.395H5.84a.341.341 0 00-.34.34v.794c0 .187.153.34.34.34h9.676l-4.396 4.396a.34.34 0 000 .482l.562.561z" fill="#2A313C" fill-rule="nonzero"/></svg>
      </div>

      <div v-if="loginState == 'working'">
        <div class='animation-wrap loading'>
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
        </div>
      </div>

      <div v-else-if="loginState == 'failed'">
        <div class='icon-wrap failed'>
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 4.84a3.464 3.464 0 013.464 3.464l.001 2.471A1.3 1.3 0 0116.33 12v6.062c0 .718-.581 1.3-1.299 1.3H8.97a1.299 1.299 0 01-1.3-1.3V12a1.3 1.3 0 01.867-1.225v-2.47A3.464 3.464 0 0112 4.84zm0 1.299c-1.144 0-2.08.887-2.16 2.01l-.005.155V10.7h4.33V8.304c0-1.196-.97-2.165-2.165-2.165z" fill="#2A313C" fill-rule="evenodd"/></svg>
        </div>
      </div>

      <div v-else-if="loginState == 'done'">
        <div class='icon-wrap done'>
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
        </div>
      </div>
    </a>

    <div class='login-submit-label' v-if="showLoginButton">
      <p class='agree-to-terms' v-localize="{key: 'login-rules', fill: ['https://provoni.platforma.one/obchodni-podminky']}"></p>
    </div>
  </form>




    <!-- newsletter checkbox -->
    <div id='login-form-legal-checks' class="new-user-legal" v-if="showLegalChecks">
      <div class='pfm-checkbox' :class="{'checked': credentials.subscription}">
        <div class='box-label-wrap'>
          <div class='box' @click="subscriptionAccepted">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-tick'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
          </div>
          <label v-localize="{key: 'login-newsletter', fill: ['http://newsletter.html']}">Newsletter....</label>
        </div>
      </div>

    </div>

  </div>



  <!-- verification code -->
  <div id="verification-screen" class="form-group awaiting-verification" v-if="loginPhase == 'awaiting-verification'">
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-mail'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14.52 14.422a3.493 3.493 0 01-6.02-2.429 3.5 3.5 0 015.6-2.8v-.7h1.4v4.55a1.05 1.05 0 002.1 0v-1.05a5.6 5.6 0 10-3.094 5.012l.63 1.253A7 7 0 1119 11.993h-.126.119v1.05a2.45 2.45 0 01-4.48 1.38h.007zM12 14.093a2.1 2.1 0 100-4.2 2.1 2.1 0 000 4.2z" fill="#2A313C" fill-rule="nonzero"/></svg>
    <div class='line-1' v-localize="{key: 'login-info-line-1', fill: [credentials.email]}"></div>

    <a id="reset-button" href="javascript:" class="wrong-email-link" @click="reset" v-localize="{key: 'button-login-reset'}">*Reset</a>

    <div class='code-error-label' v-localize="{key: 'login-code-error'}" :class="{'visible': codeError}"></div>
    <code-field id="login-pwd" key="login-pwd" :data="credentials" name="code" label='Kód' kind='input' type='number' :required=true @updated="codeChanged" :isValid="!codeError" :codeValidationChange="codeValidationChange" @backspacing="codeError = false" />

    <div v-if="['working'].includes(codeResendingState) || ['working'].includes(codeLoginState)">
      <div class='animation-wrap loading'>
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
      </div>
    </div>

    <!-- The user was found and should proceed to login -->
    <a href="javascript:" v-if="showSendAgainBtn && !['working'].includes(codeLoginState) && ['init'].includes(codeResendingState)" class="pfm-button tertriary" @click="submitAgain()" v-localize="{key: 'button-login-send-again'}">Send again</a>

    <div class='code-resent' v-if="['done'].includes(codeResendingState)">
      <p>Nový kód je na cestě!</p>
    </div>

  </div>

  <!-- User is logged in -->
  <div id='login-form-logged-in' class='login-success' v-if="loginPhase == 'user-logged-in'">
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'unlocked'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.919 4.84a3.464 3.464 0 013.464 3.464v2.598h-1.3V8.304a2.165 2.165 0 00-4.324-.155l-.005.155-.001 2.396.278.001c.718 0 1.3.582 1.3 1.299v6.062c0 .718-.582 1.3-1.3 1.3H8.97a1.299 1.299 0 01-1.299-1.3V12c0-.717.582-1.299 1.299-1.299l4.485-.001V8.304A3.464 3.464 0 0116.92 4.84z" fill="#2A313C" fill-rule="evenodd"/></svg>
    <!-- <span>Ahoj {{userFilledName}}, vítej zpátky!</span> -->
    <span>Vítej zpátky!</span>
  </div>


  <!-- If some error occures -->
  <div class="alert alert-danger" v-if="error">
    <p>{{ error }}</p>
  </div>

</div>
</template>

<script>
import User from '@/service/user'
import Cart from '@/cart'
import Notification from '@/notification'
import Utils from '@/utils';
import TextField from '@/components/common/TextField'
import CodeField from '@/components/common/CodeField'

import Validator from '@/service/Validator'

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  props: ['mainCart'],
  components: {
    TextField,
    CodeField
  },
  data() {
    return {
      Cart: Cart,
      Validator: Validator,
      loginPhase: 'setting-email',
      loginState: 'init', // working | failed | done
      codeLoginState: 'init', // working
      codeResendingState: 'init', // working | done
      codeValidationChange: {
        isValid: null
      },
      credentials: {
        email: Cart.data.userIdentification,
        code: '',
        subscription: Cart.data.userSubsribed
      },
      checkingEmail: false,
      userLoggedIn: false,
      showLoginButton: true, // Turn to true, if the email was registered already
      showLegalChecks: false, // Turn to true, if the user is quite new here
      error: '',
      userFilledName: '',
      shopName: Cart.shopData.shopName,
      userContext: User.context,
      codeError: false,
      loginBtnShaking: false,
      showSendAgainBtn: false
    }
  },
  watch: {
    userContext: {
      deep: true,
      handler() {
        console.log('User context has changed')
        this.checkUserStatus()
      }
    },
    codeError: {
      handler() {
        this.codeValidationChange.isValid = !this.codeError
      }
    },
    loginPhase: {
      handler() {
        if (this.loginPhase == 'awaiting-verification') {
          Utils.scrollTo({
            targetElementId: 'verification-screen'
          })
          setTimeout(() => {
            this.showSendAgainBtn = true
          }, 10000)
        }

        if (this.loginPhase == 'user-logged-in') {
          Utils.scrollTo({
            targetElement: 'login-form-logged-in'
          })
        }
      }
    },
  },
  created() {
    console.log('Identification:created', this.credentials)
    // this.showLoginButton
    if (Cart.data.rulesAccepted) {
      this.showLegalChecks = true
      this.$emit('change', Cart.data.rulesAccepted)
    }

    let storedPhase = window.localStorage.getItem('phase')
    if (storedPhase) {
      console.log('Site loaded with some previous login pahse', storedPhase)
      this.loginPhase = storedPhase
    }

    User.checkLogin()

    this.emailChanged()
  },
  methods: {
    ignoreForm(event) {
      event.preventDefault()
    },
    submitAgain() {
      console.log('submitAgain()')
      this.codeResendingState = 'working'
      this.requestUserCode()
    },
    submit() {
      if (this.loginPhase == 'setting-email') {
        if (this.credentials.email == '!resetcart') {
          console.log('calling cart reset')
          this.Cart.resetCart()
          return
        }

        console.log('Initializing login')
        this.loginState = 'working'
        this.Validator.validate()
          .then(res => {

            // email format not valid
            if (!res) {
              this.loginState = 'failed'
              this.shakeLoginButton()
              this.$log.error({
                path: 'cart/src/components/identification',
                fn: 'submit()',
                tags: ['login', 'triggersIntercom', 'logToCart']
              }, 'login failed: email format not valid')
              
              setTimeout(() => {
                this.loginState = 'init'
              }, 1000)
              return;
            }

            // email format valid -> check if email exists
            this.checkingEmail = true
            // Cart.data.customerMail = this.credentials.email
            // Cart.saveCart({})

            User.checkEmail(this.credentials.email)
              .then(exists => {
                console.log('EXISTS', exists)
                this.checkingEmail = false
                this.showLoginButton = exists
                this.showLegalChecks = !exists
                this.userContext.isNew = this.showLegalChecks
                Cart.data.rulesAccepted = true
                if (exists) {
                  // Email is valid, set it to the cart
                  Cart.data.userIdentification = this.credentials.email
                  Cart.saveCart()

                  console.log('Storing ', this.loginPhase)
                  this.loginPhase = 'awaiting-verification'
                  this.showLoginButton = false

                  Utils.scrollTo({
                    targetElementId: 'verification-screen'
                  })

                  // try login
                  console.log('email format valid -> trying to login')
                  this.requestUserCode()
                }

                // user doesn't exist -> create new one
                else {
                  // not something we really wanna log
                  // this.$log.error({
                  //   path: 'cart/src/components/identification',
                  //   fn: 'submit()',
                  //   tags: ['login', 'triggersIntercom', 'logToCart']
                  // }, 'login failed: user does not exist')
                  this.rulesAccepted() // tick no longer required, rules for this may be removed completely
                  this.loginState = 'init'
                  this.showLoginButton = false

                  Cart.data.userIdentification = this.credentials.email
                  Cart.saveCart()
                }
              })
          })
      }

    },
    requestUserCode() {
      var loginData = {
        lang: 'cs',
        email: this.credentials.email,
        shop: {
          id: Cart.shopId
        },
        conditions: Cart.data.rulesAccepted,
        subscription: this.credentials.subscription,
        redirectUrl: window.location.href //'http://localhost:4032/cart'
      }
      console.log('Sending ', this.loginPhase)
      User.login(loginData)
        .then(response => {
          console.log('Updating login phase', response)

          if (response == 'error') {
            this.loginPhase = 'failed'
          } else if (response == 'awaiting-verification') {
            Cart.data.rulesAccepted = true
            this.$emit('change', true)

            // it this was a resend code request
            if (this.codeResendingState == 'working') {
              this.codeResendingState = 'done'
              setTimeout(() => {
                this.codeResendingState = 'init'
              }, 5000)
            }


          } else {
            this.loginPhase = 'init'
          }
          Cart.data.orderClosed = false
          Cart.cartLoaded = true
        })
    },
    shakeLoginButton() {      
      this.loginBtnShaking = true
      setTimeout(() => {
        this.loginBtnShaking = false
      }, 1000)
    },
    reset() {
      console.log('Resetting login form')
      this.loginPhase = 'getout'
      this.$nextTick(() => {
        this.loginState = 'init'
        this.loginPhase = 'setting-email'
        this.showLoginButton = true
        Cart.data.userIdentification = ''
        this.credentials.email = ''
        Cart.data.rulesAccepted = false
        Cart.data.userSubsribed = false
        this.credentials.subscription = false
        window.localStorage.removeItem('phase')
      })

    },

    emailChanged(value, event) {
      // console.log('emailChanged()', value, event)
      // ? empty
      if (this.credentials.email == '' || this.credentials.email === undefined) {
        return
      }

      // on Enter key up
      if (event && event.keyCode === 13) {
        this.submit()
      }
    },
    codeChanged(code) {
      // Utils.onPause('login-code-change', () => {
        // if (this.credentials.code && this.credentials.code.length == 6) {
          this.codeLoginState = 'working'
          console.log('code changed, checking:', code, this.credentials.code)
          this.credentials.code = code
          User.loginWithCode(this.credentials.email, this.credentials.code)
            .then(result => {
              console.log('Login result', result)
              // code failed
              if (result == 'init') {
                this.$log.warn({
                  path: 'cart/src/components/identification',
                  fn: 'codeChanged()',
                  tags: ['login', 'triggersIntercom', 'logToCart']
                }, 'login failed: code error')
                this.codeError = true
                setTimeout(() => {
                  this.codeError = false
                }, 2000)
                this.showSendAgainBtn = true
                this.codeLoginState = 'init'
              }
            })
        // }
      // }, 100)
    },
    checkUserStatus() {
      let newUserRegistered = Utils.getCookie('nur')
      console.log('Is set newUserRegistered', newUserRegistered)
      if (this.userContext.authenticated && newUserRegistered != 'true') {

        this.loginState = 'done'

        // keep the tick icon visible for a second, then show the instructions
        setTimeout(() => {
          this.loginPhase = 'user-logged-in'
          // The email is valid - user must have accepted the rules before
          Cart.data.rulesAccepted = true
          this.rulesAccepted()
        }, 500)
      } else if (this.loginPhase != 'awaiting-verification') {
        this.loginPhase = 'setting-email'
        this.$emit('change', Cart.data.rulesAccepted == true)
        if (newUserRegistered == 'true') {
          this.showLoginButton = false
          // this.showLegalChecks = true
        }
      }
    },
    rulesAccepted() {
      console.log('Accepted?', Cart.data.rulesAccepted)
      if (Cart.data.rulesAccepted) {
        User.registerUser(this.credentials.email)
          .then(result => {
            if (result) {
              this.$emit('change', Cart.data.rulesAccepted)
            } else {
              console.error('Error while registering user, switching the rules')
              Cart.data.rulesAccepted = false
            }
          })
      } else {
        this.$emit('change', Cart.data.rulesAccepted)
      }
    },
    subscriptionAccepted() {
      this.credentials.subscription = !this.credentials.subscription
      Cart.data.userSubsribed = this.credentials.subscription
      this.$emit('change', Cart.data.rulesAccepted)
    },
  }
}
</script>

<style lang='less'>
@import '../variables.less';

#login-form {

    .first-step {
        .login-submit-label {
            p.agree-to-terms {
                text-align: center;
                font-size: 0.8rem;
                color: @pfm-color-neutral-500;
                padding: 20px 20px 0;

                a {
                    color: @pfm-color-neutral-500;
                    text-decoration: underline;
                }
            }
        }

    }
    .awaiting-verification {
        text-align: center;
        padding-bottom: 100px;

        .icon-mail {
            width: 60px;
            height: 60px;
        }

        .line-1 {
            width: 80%;
            margin: 0 auto;
        }

        a.wrong-email-link {
          text-decoration: underline;
          font-size: 0.75rem;
          color: @pfm-button-tertriary-color;
        }

        .code-error-label {
            margin: 0 auto;
            font-size: 0.75rem;
            color: @pfm-cart-color-danger;
            padding: 30px 0 10px 0;
            opacity: 0;

            &.visible {
              opacity: 1;
            }
        }

        .animation-wrap.loading {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: center;
          padding-top: 10px;

            svg {
                animation: spin 1s linear infinite;
                width: 24px;
                height: 24px;
            }
        }

        a.pfm-button.tertriary {
          padding: 0;
          margin-top: 10px;
          width: auto;
          display: inline-block;
        }

        .code-resent {
          p {
            padding-top: 10px;
          }
        }
    }

    .pfm-button.icononly {
        margin-top: 10px;
    }

    .login-success {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 40px;

        svg.unlocked {
            width: 50px;
            height: 50px;
        }

        span {}

    }

    #login-form-legal-checks {
        a {
            color: @pfm-color-neutral-800;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
